import { useSelector } from "react-redux";
import styles from "./GlobalFetching.module.scss";

const GlobalFetching = () => {
	const { isFetchingGlobal, isFetchingGlobalMessage } = useSelector((state) => state.auth);

	if (!isFetchingGlobal) return null;

	return (
		<div className={styles.overlay}>
			<div className={styles.loaderContainer}>
				<div className={styles.loader}></div>
				{isFetchingGlobalMessage?.trim() !== "" && <p className={styles.message}>{isFetchingGlobalMessage}</p>}
			</div>
		</div>
	);
};

export default GlobalFetching;
